import { useContext } from 'react';
import { Now } from 'temporal-luxon';
import { LocaleContext } from 'libs.nucleus';
var DateFormat;
(function (DateFormat) {
    DateFormat["Date"] = "date";
    DateFormat["DateTime"] = "dateTime";
})(DateFormat || (DateFormat = {}));
const DateFormatConfig = {
    [DateFormat.Date]: {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    },
    [DateFormat.DateTime]: {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    },
};
export const useDateTime = () => {
    const locale = useContext(LocaleContext);
    const { id: timeZoneID } = Now.timeZone();
    const formatDate = (date, format, options = {}) => {
        if (!date) {
            return '';
        }
        const actualDate = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(+actualDate)) {
            return '';
        }
        const resolvedTimeZone = options.ignoreTimeZone ? undefined : options.timeZone || timeZoneID;
        const formatter = new Intl.DateTimeFormat(locale, {
            ...(resolvedTimeZone && { timeZone: resolvedTimeZone }),
            ...(options.showTimeZone && { timeZoneName: 'short' }),
            ...DateFormatConfig[format],
        });
        const formattedDate = formatter.format(actualDate);
        return formattedDate;
    };
    const parseDateShort = (date, options = {}) => {
        return formatDate(date, DateFormat.Date, options);
    };
    const parseDateTimeShort = (date, options = {}) => {
        return formatDate(date, DateFormat.DateTime, options);
    };
    return { parseDateShort, parseDateTimeShort };
};
